import { render, staticRenderFns } from "./Yasf.vue?vue&type=template&id=0d965542"
import script from "./Yasf.vue?vue&type=script&lang=js"
export * from "./Yasf.vue?vue&type=script&lang=js"
import style0 from "./Yasf.vue?vue&type=style&index=0&id=0d965542&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports